import React, { useCallback, FC, useMemo } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import ReactGA from "react-ga4";

import styles from "../index.module.scss";
import ChartFallback from "src/shared/components/ChartFallback";
import Shimmer from "src/shared/components/CustomisedShimmer";

interface ISearchItem {
  bigNumber: string;
  vCompare: string;
  label: string;
  id: number;
  progress: boolean;
  successful: boolean;
  pending: boolean;
  hasChart: boolean;
  isPositive: boolean;
}

const SearchItem: FC<ISearchItem & RouteComponentProps> = (props) => {
  const { bigNumber, vCompare, label, id, progress, successful, hasChart, isPositive } = props;

  const barsConfig = useMemo(
    () => [
      {
        height: "1.872rem",
        width: "4.16rem",
        repeatBar: 1,
      },
      {
        height: "1.24rem",
        width: "5.52rem",
        repeatBar: 1,
        style: { marginTop: "5%" },
      },
    ],
    []
  );

  const showDetails = useCallback((ev: React.MouseEvent) => {
    if (ev) {
      const searchId = ev.currentTarget.getAttribute("data-item");
      props.history.push(`/details/metric/${searchId}`);
      ReactGA.event({
        category: "Metric Clicked from Search",
        label: `Metric: ${label} on Search`,
        action: "Click from Search",
      });
    }
  }, []);

  return (
    <div className={styles["search-item"]} onClick={showDetails} data-item={id}>
      <div className={styles["item-title"]}>{label}</div>
      {successful && (
        <div className={styles["item-charts"]}>
          <div className={styles["chart-number"]}>{bigNumber}</div>
          <div
            className={
              vCompare === ""
                ? styles["chart-progress-neutral"]
                : `${progress == isPositive ? styles["chart-progress-up"] : styles["chart-progress-down"]} ${
                    progress ? styles["up-arrow"] : styles["down-arrow"]
                  }`
            }
          >
            {vCompare}
          </div>
        </div>
      )}
      {!hasChart && !successful && <Shimmer className={styles["shimmer-group"]} barsConfig={barsConfig} />}
      {/* TODO: fallback */}

      {!successful && hasChart && (
        <div className={styles["item-charts-404"]}>
          <ChartFallback />{" "}
        </div>
      )}
    </div>
  );
};

export default withRouter(SearchItem);
